<div class="filter-block d-flex align-items-center">
  <select id="status-select" class="form-select" name="status" [(ngModel)]="selectedRange"
    (change)="onRangeClick($event.target.value)">
    <option *ngFor="let range of ranges" [value]="range?.value">{{ range?.label }}</option>
  </select>
</div>